import { h } from "preact";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));

export default function Picto1() {
	const classes = useStyles();

	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46.96 50.4" width="47px">
			<g id="design">
				<path d="M1.07,0A1.07,1.07,0,0,0,0,1.07V46.14a1.07,1.07,0,0,0,1.07,1.07H26.78A12,12,0,1,0,37.44,26.53V14c.22-.34-13.22-14-13.22-14ZM2.14,2.15h21V13.41a1.06,1.06,0,0,0,1.07,1.07H35.3V26.27h-.37a12.06,12.06,0,0,0-10,18.8H2.14ZM25.31,3.66,34,12.34H25.31ZM9,10.73a1.07,1.07,0,0,0-1.09,1,1.06,1.06,0,0,0,1,1.09,0,0,0,0,0,.05,0h7.46a1.07,1.07,0,0,0,.05-2.14H9Zm0,6.44a1.07,1.07,0,1,0,0,2.14h20.3a1.07,1.07,0,0,0,0-2.14ZM9,23.6a1.08,1.08,0,0,0,0,2.15h20.3a1.08,1.08,0,0,0,0-2.15Zm25.94,4.85a9.88,9.88,0,1,1-9.85,9.88A9.85,9.85,0,0,1,34.93,28.45ZM9,30a1.08,1.08,0,0,0,0,2.15H21.8a1.08,1.08,0,0,0,0-2.15Zm31.29,4a1.05,1.05,0,0,0-.75.3L33.4,40.08l-3.09-2.89a1.07,1.07,0,0,0-1.5,1.53l.05.05,3.81,3.56a1.06,1.06,0,0,0,1.46,0L41,35.91a1.08,1.08,0,0,0,.07-1.52A1.05,1.05,0,0,0,40.28,34ZM16.51,36.48H9a1.07,1.07,0,1,0-.12,2.14.24.24,0,0,0,.12,0h7.46a1.07,1.07,0,0,0,.1-2.14Z" />
			</g>
		</svg>
	);
}
